import React from "react";
import { useShellTheme } from "../layout/ShellTheme";

/**
 * Reusable general wellness education disclaimer (not medical advice).
 * @param {{ className?: string, compact?: boolean }} props
 */
export default function WellnessDisclaimer({ className = "", compact = false }) {
  const dark = useShellTheme() === "dark";
  const text =
    "Information on this site is for general wellness education only and is not medical advice. Sea moss and herbs may not be suitable for everyone. Sea moss and sea botanicals (such as bladderwrack) naturally contain iodine. If you are pregnant, breastfeeding, taking medication, managing a thyroid condition, or unsure, please speak with a qualified healthcare professional before using sea moss or herbal supplements.";

  if (compact) {
    return (
      <aside
        className={`text-[11px] leading-relaxed ${dark ? "text-sage/80" : "text-botanical/75"} ${className}`}
        role="note"
      >
        {text}
      </aside>
    );
  }

  return (
    <aside
      className={`rounded-2xl px-5 py-4 text-xs leading-relaxed ${
        dark
          ? "border border-white/14 bg-panel/80 text-sage"
          : "border border-cream bg-offwhite/80 text-botanical/80"
      } ${className}`}
      role="note"
    >
      <strong className={`font-medium ${dark ? "text-ivory" : "text-forest"}`}>Note:</strong> {text}
    </aside>
  );
}
